import { jwtDecode } from 'jwt-decode';

import { queryClient } from '@/app/config/react-query';
import { getJWTQuery } from '@/queries/get-jwt';
import { useUserStore } from '@/store/userStore';

export async function homeLoader() {
  const {
    data: { jwtToken },
  } = await queryClient.fetchQuery(getJWTQuery);

  const {
    currentContext: { companyId, roles },
  } = jwtDecode<{ currentContext: { companyId: string; roles: string[] } }>(jwtToken) || {
    currentContext: { companyId: '', roles: [] },
  };

  if (jwtToken) {
    useUserStore.setState(() => ({
      jwtToken,
      isAuthenticated: true,
      supplierId: companyId,
      isAdmin: roles.includes('ROLE_ADMIN'),
    }));
  }

  return useUserStore.getState().isAuthenticated;
}
